import { Box, Stack, TableRow } from "@mui/material";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import { useState } from "react";
import { ICONS, SPActionType } from "../constants/enums";
import Button from "./Button";
import ConfirmDialog from "./ConfirmDialog";
import Heading from "./Heading";
import Input from "./Input";

function ReactTable({
  isEdit,
  columns,
  tableData,
  onInputChange,
  onButtonHandler,
}: any) {
  const [openConfirmation, setOpenConfirmation] = useState(false);
  const [index, setIndex] = useState<number | null>(null);

  return (
    <Paper
      sx={{
        width: "100%",
        overflow: "hidden",
        background: "#fff",
      }}
    >
      <TableContainer sx={{ maxHeight: 440 }} className="reactTable">
        <Table stickyHeader aria-label="sticky table">
          <TableHead>
            <TableRow>
              {columns.map((column: any) => (
                <TableCell
                  key={column.field}
                  sx={{
                    padding: "10px",
                    backgroundColor: "var(--color-light-grey)",
                    borderRight: "1px solid var(--color-default)",
                    minWidth: column.width,
                  }}
                >
                  <Heading
                    text={column.headerName}
                    isBold={true}
                    type="body1"
                  />
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          {tableData && tableData.length > 0 && (
            <TableBody>
              {tableData.map((row: any, index: number) => (
                <TableRow hover role="checkbox" tabIndex={-1} key={row.id}>
                  {columns.map((column: any) => (
                    <TableCell
                      key={column.field}
                      className={
                        column.field === "comments" ? "comment-col" : ""
                      }
                      sx={{
                        padding: "10px",
                      }}
                    >
                      <Input
                        id={row[column.field]}
                        value={row[column.field]}
                        size="small"
                        disabled={isEdit}
                        multiline={true}
                        maxRows="4"
                        minRows="4"
                        onChange={(e) => {
                          e.stopPropagation();
                          onInputChange(e.target.value, column.field, index);
                        }}
                      />
                      {column.field === "comments" && !isEdit && (
                        <span
                          className="material-symbols-outlined delete-icon"
                          onClick={() => {
                            setOpenConfirmation(true);
                            setIndex(index);
                          }}
                        >
                          delete
                        </span>
                      )}
                    </TableCell>
                  ))}
                </TableRow>
              ))}
            </TableBody>
          )}
          {(tableData === null || tableData.length === 0) && (
            <TableBody>
              <TableRow style={{ height: 150 }}>
                <TableCell colSpan={7}>
                  <Stack
                    height="100%"
                    alignItems="center"
                    justifyContent="center"
                    fontSize="1rem"
                    color={"var(--color-border-model)"}
                  >
                    No data available.
                  </Stack>
                </TableCell>
              </TableRow>
            </TableBody>
          )}
        </Table>
      </TableContainer>

      <Box
        sx={{
          display: "flex",
          justifyContent: "end",
          alignItems: "center",
          padding: "10px",
        }}
      >
        {!isEdit && (
          <Button
            text="cancel"
            variant="outlined"
            className="ml-1"
            fullWidth={false}
            onClick={(e) => {
              onButtonHandler(SPActionType.CANCEL);
            }}
          />
        )}
        <Button
          text={isEdit ? "Edit" : "Update"}
          className="ml-1"
          fullWidth={false}
          onClick={(e) => {
            onButtonHandler(isEdit ? SPActionType.EDIT : SPActionType.SUBMIT);
          }}
        />
      </Box>
      <ConfirmDialog
        text={`Are you sure you want to delete this record?`}
        confirmText="Delete"
        cancelText="Cancel"
        dialogOpen={openConfirmation}
        setDialogOpen={() => {
          setOpenConfirmation(false);
          setIndex(null);
        }}
        handleConfirm={() => {
          onButtonHandler("delete", index);
          setOpenConfirmation(false);
          setIndex(null);
        }}
        icon={ICONS.DELETE}
        className="delete-icon"
        width="xs"
      />
    </Paper>
  );
}

export default ReactTable;
